export class LoginState {
    public password: string = ''
    public email: string = ''
    public isValid: boolean = false 
    public updatePassword: boolean = false
}


// WEBPACK FOOTER //
// ./src/components/login/LoginState.ts